// extracted by mini-css-extract-plugin
export default {"section":"Dialogs_section__I2QH+","scrollable":"Dialogs_scrollable__os8x0"};